module.exports = __webpack_public_path__ + "static/imacGlare@2x-9c459354dcac406e40e41089ff0fddc0.png";